import React, { type SVGProps } from 'react'

const InfoIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      d="M24.8 49.6C38.4981 49.6 49.6 38.4981 49.6 24.8C49.6 11.1019 38.4981 0 24.8 0C11.1019 0 0 11.1019 0 24.8C0 38.4981 11.1019 49.6 24.8 49.6ZM21.7 15.5C21.7 13.7853 23.0853 12.4 24.8 12.4C26.5147 12.4 27.9 13.7853 27.9 15.5C27.9 17.2147 26.5147 18.6 24.8 18.6C23.0853 18.6 21.7 17.2147 21.7 15.5ZM20.925 21.7H25.575C26.8634 21.7 27.9 22.7366 27.9 24.025V32.55H28.675C29.9634 32.55 31 33.5866 31 34.875C31 36.1634 29.9634 37.2 28.675 37.2H20.925C19.6366 37.2 18.6 36.1634 18.6 34.875C18.6 33.5866 19.6366 32.55 20.925 32.55H23.25V26.35H20.925C19.6366 26.35 18.6 25.3134 18.6 24.025C18.6 22.7366 19.6366 21.7 20.925 21.7Z"
      fill="currentColor"
    />
  </svg>
)

export default InfoIcon
